module.exports = __webpack_public_path__ + "static/media/hizaNobashi.66974e36.png";